;(function(){

  var mobileCheck = function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };
  

	var _getProductHash = function(cityName){
		
	
		var productHash={
      'homepage' : {
        'name': 'Featured',
        'url': '/local/' + cityName + '/featured-activities-in-' + cityName,
        'description' : 'Experience & Book the best activities, restaurants & events on Cleartrip'
      },
			'ttd': {
        'name': 'Activities',
        'url': '/local/' + cityName + '/things-to-do-in-' + cityName,
        'iconName': 'localActivitiesIcon',
        'description': 'Explore 1000s of things to do in and around your city'
		  },
      'fnb': {
        'name': 'Eat Out',
        'url': '/local/' + cityName + '/food-and-drinks-in-' + cityName,
        'iconName': 'localEatOutIcon',
        'description': 'Enjoy curated dining experiences at the best restaurants'
      },
      'events': {
        'name': 'Events',
        'url': '/local/' + cityName + '/events-in-' + cityName,
        'iconName': 'localEventsIcon',        
        'description': 'There&lsquo;s a lot happening in your city. Never be bored again'
      },
      'fit': {
        'name': 'Fitness',
        'url': '/local/' + cityName + '/fitness-in-' + cityName,
        'iconName': 'localFitnessIcon',        
        'description': 'Get fit at over 1200 gyms in your city and elsewhere with one pass'
      }
    };

    //if(mobileCheck()){
    //  delete productHash.homepage;
    //}
    return productHash;
	}
	
  localsHome = {
		  
	getProductHash: _getProductHash,	  
    
	helpers: {
      replace: function(str,a,b) {
        if (str && typeof str === 'string') {
          if (!a || typeof a !== 'string') return str;
          if (!b || typeof b !== 'string') b = '';
          return str.split(a).join(b);
        }
      }
    },
    showLocalSpace: function() {
      $('.spacesReel').addClass('isShowingLocal');
      $('#space_local').prop('checked', true);
      $('#space_travel').prop('checked', false);
      $('.localFrame').off('click.toggleSpaces');      
      $('.travelFrame').on('click.toggleSpaces', localsHome.showTravelSpace);

      CT.utils.cookies.create('spacePreference', 'local', 365);
      $localOverlay = $('.localFrame').find('.transparentOverlay');
      $travelOverlay = $('.travelFrame').find('.transparentOverlay');
      if ($localOverlay) {
        $localOverlay.css('display', 'none');
      }
      if ($travelOverlay) {
        $travelOverlay.css('display', 'block');
      }
      try{
        if(CT && CT.utils && CT.utils.helperFunctions && CT.utils.helperFunctions.tpTrack && window.cleverTapEnabled){
          var pageLoadObj = {
          	"event type" : "local home page",
          	"last event type" : CT.utils.cookies.read("lastEventType") ? CT.utils.cookies.read("lastEventType") : "new session",
          	"city" : _.capitalize(window.currentCityName),
			"user location" :  CT.utils.cookies.read("userLocation") ? _.capitalize(CT.utils.cookies.read("userLocation")) : "NA",
			"collection name" : "NA",
			"collection type" : "NA",
			"activity name" : "NA",
			"price" : -1,
			"activity location" : "NA",
			"distance" : -1,
			"dx" : -1,
			"srp position" : -1,
			"platform" : window.isMobileUA ? "mweb" : "desktop"
          }
          CT.utils.cookies.create("lastEventType", "local home page");
          CT.utils.helperFunctions.tpTrack({"tp":"clevertap", "category":"local page viewed","values":pageLoadObj});
        }
      }catch(e){window.console && console.log(e)}
      	setTimeout(function(){
			if(typeof(window.google_trackConversion) == "function"){
		      	window.google_trackConversion({
				  google_conversion_id: 995874483, 
				  google_custom_params: {"local_id" : "0", "local_pagetype" : "home"},
				  google_remarketing_only: true
				});
			}
			if(window.fbq){
		    	fbq('track', 'ViewContent', {content_type: 'local', content_ids: ['0']});
			}
		}, 1000)
    },
    showTravelSpace: function() {
      $('.spacesReel').removeClass('isShowingLocal');
      $('#space_travel').prop('checked', true);
      $('#space_local').prop('checked', false);
      //$('.travelFrame').off('click.toggleSpaces');
      //$('.localFrame').on('click.toggleSpaces', localsHome.showLocalSpace);

      CT.utils.cookies.create('spacePreference', 'travel', 365);
      $localOverlay = $('.localFrame').find('.transparentOverlay');
      $travelOverlay = $('.travelFrame').find('.transparentOverlay');
      if ($localOverlay) {
        $localOverlay.css('display', 'block');
      }
      if ($travelOverlay) {
        $travelOverlay.css('display', 'none');
      }
    },
    cTapTrackOnSwitch:function(space){
    	try{
    		var eventName = "";
    		if(space && space == 'local'){
    			eventName = "travel to local switch";
    		}else if(space && space == 'travel'){
    			eventName = "local to travel switch";
    		}
	        if(CT && CT.utils && CT.utils.helperFunctions && CT.utils.helperFunctions.tpTrack && window.cleverTapEnabled && eventName != ""){
	          var obj = {
	            "event type" : eventName,
	            "destination" : space,
	            "last event type" : CT.utils.cookies.read("lastEventType") ? CT.utils.cookies.read("lastEventType") : "new session",
	            "city" : _.capitalize(window.currentCityName),
	            "time elapsed in the session" : (window.clevertap && clevertap.session && clevertap.session.getTimeElapsed()) ? clevertap.session.getTimeElapsed() : -1,
	            "platform" : window.isMobileUA ? "mweb" : "desktop",
	            "user location" :  CT.utils.cookies.read("userLocation") ? _.capitalize(CT.utils.cookies.read("userLocation")) : "NA"
	          }
	          CT.utils.cookies.create("lastEventType", eventName);
	          CT.utils.helperFunctions.tpTrack({"tp":"clevertap", "category":"screen switch","values":obj});
	        }
      	}catch(e){}
    },
    cTapTrackOnLoad : function(){
      try{
        if(CT && CT.utils && CT.utils.helperFunctions && CT.utils.helperFunctions.tpTrack && window.cleverTapEnabled){
            var obj = {
              "event type" : "cleartrip home viewed",
              "last event type" : CT.utils.cookies.read("lastEventType") ? CT.utils.cookies.read("lastEventType") : "new session",
              "city" : _.capitalize(window.currentCityName),
              "platform" : window.isMobileUA ? "mweb" : "desktop",
              "user location" :  CT.utils.cookies.read("userLocation") ? _.capitalize(CT.utils.cookies.read("userLocation")) : "NA"
            }
            CT.utils.cookies.create("lastEventType", "cleartrip home viewed");
            CT.utils.helperFunctions.tpTrack({"tp":"clevertap", "category":"cleartrip home viewed","values":obj});
          }
        }catch(e){}
    },
    cleverTapCityClickTrack: function(cityName){
    //cleverTap tracking on change city clicked
    try{
        if(window.cleverTapEnabled){
        var cTapObj = {
          "event type" : "city picker clicked",
          "last event type" :  (CT && CT.utils && CT.utils.cookies && CT.utils.cookies.read && CT.utils.cookies.read("lastEventType")) ? CT.utils.cookies.read("lastEventType") : "new session",
          "city" : cityName,
          "user location" : (CT && CT.utils && CT.utils.cookies && CT.utils.cookies.read && CT.utils.cookies.read("userLocation"))? CT.utils.cookies.read("userLocation") : "NA",
          "collection name" : "NA",
          "collection type" : "NA",
          "activity name" : "NA",
          "activity location" : -1,
          "price" : -1,
          "distance" : -1,
          "dx" : -1,
          "action" : "NA",
          "srp position" : -1,
          "platform" : window.isMobileUA ? "mweb" : "desktop"
        }
        CT.utils.helperFunctions.tpTrack({"tp":"clevertap", "category":"local action", "values":cTapObj});
        if(CT && CT.utils && CT.utils.cookies && CT.utils.cookies.create)CT.utils.cookies.create("lastEventType", "city picker clicked");
      }
    }catch(e){}
    },
    setHeightForLocalWeb: function() {
     /* var windowHeight = $( window ).height();
      var headerHeight = $('#GlobalNav').outerHeight();
      var footerHeight = $('footer').outerHeight();

      var spacesViewHeight = windowHeight - ( headerHeight + footerHeight ) - 10;
      spacesViewHeight = ( spacesViewHeight > 860 ) ? spacesViewHeight : 860;
      var travelSpaceHeight = spacesViewHeight - 100;
      
      $('.spacesView').css('min-height', spacesViewHeight);
      $('.searchForm').css('min-height', travelSpaceHeight);
      $('.spacesFrame').css('min-height', travelSpaceHeight + 80);*/
      
    	 var asideLeftHeight = $('#Home').find('aside').first().outerHeight(),
	     asideRightHeight = $('#Home').find('aside').last().outerHeight(),
	     windowHeight = $(window).outerHeight(),
	     appBannerHeight = $('#homeUpsellBanner').outerHeight(),
	     appBannerHeight = appBannerHeight?appBannerHeight:'0';
	 
	// var height = Math.max(asideLeftHeight, asideRightHeight, windowHeight - 100 - appBannerHeight);
	 var height = $(".travelFrame").outerHeight();
	 //$('.localFrame').css({'height': height + 'px','overflow':"hidden"});
    	
    	
    	
    },
    carouselSliderClick: function(e) {
    	var sliderURL = $(e.currentTarget).find('.carouselSlide').attr('data-url');
    	var location = window.location;
    	if (sliderURL) {
    		window.location.href = sliderURL
    	}
    },
    setEventsForLocalWeb: function() {
      // $('#space_travel').on('change', function() {
      //   (this.checked) ? localsHome.showTravelSpace() : null;
      // });

      // $('#space_local').on('change', function() {
      //   (this.checked) ? localsHome.showLocalSpace() : null;
      // });
      
     

      // $(document).on('keydown', function(event) {
      //  switch(event.which) {
      //    case 37: // left
      //     if(event.target.nodeName != "INPUT"){
      //       localsHome.showTravelSpace();
      //     }
      //      break;

      //    case 39: // right
      //     if(event.target.nodeName != "INPUT"){
      //        localsHome.showLocalSpace();
      //     } 
      //      break;

      //    default: return; // exit this handler
      //   }
      // });

      // Initiate default state and event bindings
     // localsHome.setSpacePreference();
      localsHome.setHeightForLocalWeb();      
    },
    filterCarouselById: function(carouselData, crossProducts) {
      var filterCarousels = [];
      if(carouselData && carouselData.length && crossProducts && crossProducts.length){
        _.each(carouselData, function(carousel){
          if(_.indexOf(crossProducts, carousel.id) > -1 && filterCarousels.length < 3 && carousel.type == 'collection'){
            filterCarousels.push(carousel);
          }
        });
      }
      return filterCarousels;
    },
    fetchEditorialForLocation: function(cityName) {
      if (cityName){
        try{
          $.ajax({
            method: 'GET',
            url: '/local/api/v1/ttd/search?city=' + cityName + '&editorial=true',
            contentType: "application/json",
            dataType: "json",
            success: function(data){
              data = _.isString(data)? JSON.parse(data) : data;
              window.localData = data;
              if(data.editorial || data.collections){
                localsHome.generateEditorialData(data);
              } else {
                localsHome.showCityUnavailable();
              }
            },
            error: function(err){
              console.log(err);
              localsHome.showCityUnavailable();
            }
          });
        }catch(e){
          console.log(e);
          localsHome.showCityUnavailable();
        }  
      }  
    },    
    generateEditorialData: function(ttdData) {
      var editorialJSON = ttdData.editorial;
      var finalEditorialJSON = [];
      var products = ['ttd', 'fnb', 'events'];
      var productIds = {
        'ttd': 1,
        'fnb': 2,
        'events': 3
      };
      var carouselLimit = 4;
      var imageBasePath = window.airBaseLink ? window.airBaseLink : '//www.cleartrip.com';

      var fetchFromCP = function() {
        var carouselCount = 0;
        var carouselIds = [];
        _.each(products, function(product) {
          if (editorialJSON[product].cp && editorialJSON[product].cp.length && finalEditorialJSON.length < carouselLimit && carouselIds.length < carouselLimit) {
            carouselIds.push(editorialJSON[product].cp.shift());
            carouselCount += editorialJSON[product].cp.length;
          }
        });
        filteredCarousels = localsHome.filterCarouselById(editorialJSON.carousel, carouselIds);
        _.each(filteredCarousels , function(carousel){
          finalEditorialJSON  = _.uniq(finalEditorialJSON,function(obj){return obj.id});
          if (finalEditorialJSON.length < carouselLimit) {
            carousel.dataType = 'cp';
            finalEditorialJSON.push(carousel);
          }
        })
        if (carouselCount && finalEditorialJSON.length < carouselLimit) {
          fetchFromCP();
        } else {
          return false;
        }
      };

      var fetchFromPE = function() {
        _.each(products, function(product) {
          finalEditorialJSON = _.uniq(finalEditorialJSON,function(obj){return obj.id});
          if(editorialJSON[product].p && editorialJSON[product].p.collection && editorialJSON[product].p.collection.length && finalEditorialJSON.length < carouselLimit){
            var productEditorial = editorialJSON[product].p.collection.shift();
            productEditorial.dataType = 'pe';
            productEditorial.productId = productIds[product];
            finalEditorialJSON.push(productEditorial);
          }
        });
      };

      var fetchFromCollection = function(){
        _.each(ttdData.collections,function(collection){
         finalEditorialJSON =  _.uniq(finalEditorialJSON,function(obj){return obj.id});
          if(finalEditorialJSON.length < carouselLimit){
            var collectionData  = collection;
            collectionData.dataType =  "collection";
            collectionData.productId = 1;
            finalEditorialJSON.push(collectionData);
          }
        });
      }

      if(editorialJSON){
        fetchFromCP();  
      }
      
      if (editorialJSON && finalEditorialJSON.length < carouselLimit) {
        fetchFromPE();
      }

      if(finalEditorialJSON.length < carouselLimit){
        fetchFromCollection();
      }
      
      var collectionData = [];
      _.each(finalEditorialJSON, function(editorial, index){
        var finalItem = {};

        if (editorial.dataType == 'cp') {
          finalItem.image = (editorial.images && editorial.images.length && editorial.images[0].img) ? editorial.images[0].img : '';
          finalItem.title = editorial.title;
          finalItem.id = editorial.id;
          //editorial.callback = editorial.callback.replace('?','&')
          finalItem.url = '/local/' + window.currentCityName + '/editorial?callback=' + editorial.callback + '&type=' + editorial.type + '&product=' + editorial.product.toLowerCase() + '';
        } else {
          finalItem.image = editorial.image || '';
          finalItem.title = editorial.collection_name;
          finalItem.id = editorial.id;
          finalItem.url = '/local/' + window.currentCityName + '/' + localsHome.helpers.replace(editorial.collection_name.toLowerCase(), ' ', '_') + '-in-' + window.currentCityName + '-collection-' + editorial.id + '-' + editorial.productId;
        }

        finalItem.image = imageBasePath + '/' + finalItem.image.replace('{type}', 'w');
        collectionData.push(finalItem)

      });
      var cityDisplayName = _.capitalize(window.currentCityName);
      var localCarouselHtml = CT.to_html('LocalCarouselTemplate', {'cityName': cityDisplayName});
      var localCollectionsHtml = CT.to_html('LocalCollectionsTemplate', {'isCollectionAvailable': collectionData.length ? true : false,'collectionData': collectionData, 'cityName': cityDisplayName});      
      $('#localCarousel').html(localCarouselHtml);
      $('#localCollections').html(localCollectionsHtml);
      localsHome.showCityAvailable();   
    },
    getLocalHomePage: function(localProductHash){
      var city = window.localDefaultCity.toLowerCase();
      if(localProductHash.homepage == true){
        city = window.currentCityName.toLowerCase();
        console.log(window.currentCityName);
      }
      var getDistance = function(event){
        var userLat =  -1;
        var userLng =  -1;
        var distance = -1;
        var currentTarget = $(event.currentTarget);

        if(CT.utils.cookies.read("userLatitude") && CT.utils.cookies.read("userLongitude")){
              userLat = CT.utils.cookies.read("userLatitude");
              userLng = CT.utils.cookies.read("userLongitude");
            }else if (navigator.geolocation && navigator.geolocation.getCurrentPosition){
              navigator.geolocation.getCurrentPosition(function(position){
                if (position.coords && position.coords.latitude && position.coords.longitude) {
                  userLat =  position.coords.latitude;
                  userLng = position.coords.longitude;
                }
             })
          }

          if(userLat != -1 && userLng != -1){
            var activityLat = currentTarget.data('lat');
            var activityLng = currentTarget.data('lng');
            distance = CT.utils.helperFunctions.getDistanceFromLatLonInKm(userLat, userLng, activityLat, activityLng);
          }

          return distance;
      }

      var setCtSessionObject  = function(cTapObj){
          if(window.sessionStorage){
              window.sessionStorage.setItem("clevertap", JSON.stringify(cTapObj));
          }
      };

      var getCtSessionObject = function(){
          var cTapObj;
          if(window.sessionStorage){
              if (!window.sessionStorage.getItem("clevertap")) {
                  window.sessionStorage.setItem("clevertap", JSON.stringify({}));  
              }
              cTapObj = window.sessionStorage.getItem("clevertap");
              cTapObj = JSON.parse(cTapObj);
          }
          return cTapObj;
      };

      var clevertapAttributes  = function (event){
        //var modelData = this.model.toJSON();
        var currentTarget = $(event.currentTarget);
        var usrLocation = (CT && CT.utils && CT.utils.cookies && CT.utils.cookies.read && CT.utils.cookies.read("userLocation"))? CT.utils.cookies.read("userLocation") : "NA";
        var lastEventType = (CT && CT.utils && CT.utils.cookies && CT.utils.cookies.read && CT.utils.cookies.read("lastEventType")) ? CT.utils.cookies.read("lastEventType") : "new session";
        var sectionName = $(event.currentTarget).closest('.localModule__block')
            .find('.localModule__block__title').text();
        var srpHorizontal = $(event.currentTarget).data('srp');
        var parentContainer = currentTarget.closest("#localLongForm").find('.localModule');
        var thisContainer = currentTarget.closest(".localModule");
        var srpPosition = parseInt(parentContainer.index(thisContainer));
        
        if(window.cleverTapEnabled){
            var cTapObj = {
                "event type" : "cleartrip home local search",
                "last event type" : lastEventType,
                "city" : city,
                "user location" : usrLocation,
                "collection name" : "NA",
                "collection type" : "NA",
                "organiser name" : "NA",
                "activity name" : "NA",
                "section name" : sectionName ? sectionName : "NA",
                "activity location" : "NA",
                "price" : "NA",
                "distance" : -1,
                "dx" : -1, 
                "action" : "NA",
                "srp position" : srpPosition,
                "srp horizontal" : srpHorizontal,
                "platform" : window.isMobileUA ? "mweb" : "desktop",
                "rating" : 0,  //default
                "reviews" : 0, //default
                "reviews summary" : "no", //default
                "locality selected" : "NA", //default
                "activity date" : "NA" //default; change only for event carousel template.
            };
        }
        return cTapObj;
      }
      var clevertapSearchAttributes = function(event){
        //var modelData = this.model.toJSON();
        var currentTarget = $(event.currentTarget);
        var usrLocation = (CT && CT.utils && CT.utils.cookies && CT.utils.cookies.read && CT.utils.cookies.read("userLocation"))? CT.utils.cookies.read("userLocation") : "NA";
        var lastEventType = (CT && CT.utils && CT.utils.cookies && CT.utils.cookies.read && CT.utils.cookies.read("lastEventType")) ? CT.utils.cookies.read("lastEventType") : "new session";
        var sectionName = $(event.currentTarget).closest('.localModule__block')
            .find('.localModule__block__title').text();
        var srpHorizontal = $(event.currentTarget).data('srp');
        var  parentContainer = currentTarget.closest("#localLongForm").find('.localModule');
        var thisContainer = currentTarget.closest(".localModule");
        var srpPosition = parseInt(parentContainer.index(thisContainer)); 
        if(window.cleverTapEnabled){
            var cTapObj = {
                "event type" : "cleartrip home local search",
                "last event type" : lastEventType,
                "city" : city,
                "user location" : usrLocation,
                "search type" : -1,
                "section name" : sectionName ? sectionName : "NA",
                "activity name" : "NA",
                "collection name" : "NA",
                "organiser name" : "NA",
                "platform" : window.isMobileUA ? "mweb" : "desktop",
                "activity date" : "NA",
                "srp position" : srpPosition,
                "srp horizontal" : srpHorizontal,
                "product name" : "NA",
                "story category" : "NA"
            };

            if(window.sessionStorage){
              var sessionObject = getCtSessionObject();
              sessionObject["srp position"] = srpPosition;
              sessionObject["srp horizontal"] = srpPosition;
              sessionObject["section name"] = sectionName;
              setCtSessionObject(sessionObject);  
            }
        }
        return cTapObj;
      }
      var trackActivityListing = function (event) {
        var currentTarget = $(event.currentTarget);
        var cTapObj = clevertapAttributes(event);
        var cTapSearchObj = clevertapSearchAttributes(event);
        
        cTapObj["distance"] = getDistance(event);
        cTapSearchObj["activity name"] = cTapObj["activity name"] = currentTarget.data('activityName');
        cTapObj["activity location"] = currentTarget.data('activityLocation');
        cTapObj["price"] = currentTarget.data('price');
        window.actTypeCleverTap = cTapSearchObj["search type"] = cTapObj["collection type"] = cTapObj["action"] = "ct home activity rows";
        
        cTapSearchObj["product name"] = currentTarget.data('product');

        if(window.sessionStorage){
          var sessionObject = getCtSessionObject();
          sessionObject["source"] = cTapSearchObj["search type"];
          setCtSessionObject(sessionObject);  
        }

        CT.utils.helperFunctions.tpTrack({"tp":"clevertap", "category":"local search", "values":cTapSearchObj});
        if(CT && CT.utils && CT.utils.cookies && CT.utils.cookies.create){
          CT.utils.cookies.create("lastEventType", "cleartrip home local search");
        }
      }
      var trackCollectionCards = function(event){
        var cTapObj = clevertapAttributes(event);
        var cTapSearchObj = clevertapSearchAttributes(event);
        var currentTarget = $(event.currentTarget);

        window.actTypeCleverTap = cTapSearchObj["search type"] = cTapObj["action"] = cTapObj["collection type"] = "ct home product editorial";
        cTapSearchObj["collection name"] = cTapObj["collection name"] = currentTarget.data('collectionName');
        cTapSearchObj["product name"] = currentTarget.data('product');
        if(currentTarget.data('product') == 'fnb'){
          cTapSearchObj["organiser name"] = currentTarget.data('collectionName');
          cTapObj["organiser name"] = currentTarget.data('collectionName');
        }

        if(window.sessionStorage){
          var sessionObject = getCtSessionObject();
          sessionObject["source"] = cTapSearchObj["search type"];
          setCtSessionObject(sessionObject);  
        }

        //Trigger a local search
        CT.utils.helperFunctions.tpTrack({"tp":"clevertap", "category":"local search", "values":cTapSearchObj});
        if(CT && CT.utils && CT.utils.cookies && CT.utils.cookies.create){
          CT.utils.cookies.create("lastEventType", "cleartrip home local search");
        }
      }
      var trackStories = function(event){
        var currentTarget = $(event.currentTarget);
        //var cTapObj = clevertapAttributes(event);
        var cTapSearchObj = clevertapSearchAttributes(event);

        cTapSearchObj["product name"] = "stories";
        cTapSearchObj["story category"] = currentTarget.data('tag');
        cTapSearchObj["search type"] = "ct home story web view";

        CT.utils.helperFunctions.tpTrack({"tp":"clevertap", "category":"local search", "values":cTapSearchObj});
        if(CT && CT.utils && CT.utils.cookies && CT.utils.cookies.create){
          CT.utils.cookies.create("lastEventType", "cleartrip home local search");
        }
      }
      var trackEvent = function(event){
        //event.preventDefault();
        var currentTarget = $(event.currentTarget);
        var cTapSearchObj = clevertapSearchAttributes(event);
        var actDate = moment(currentTarget.data("startDate")).format("DD/MM/YYYY");
        var today = moment(new Date()).format("DD/MM/YYYY");
        window.actTypeCleverTap = cTapSearchObj["search type"] = "home event editorial";
        cTapSearchObj["activity name"] = currentTarget.data("activity");
        cTapSearchObj["organiser name"]  =  currentTarget.data("source");
        cTapSearchObj["activity date"] =  actDate ? actDate : "NA";
        //cTapObj["price"] = currentTarget.data("price");
        //cTapObj["activity location"] = currentTarget.data("activityLocation");
        //cTapObj["dx"] = CT.utils.diffDates(today, actDate) ? CT.utils.diffDates(today, actDate) : -1;
        cTapSearchObj["product name"] = currentTarget.data('product');
        //cTapObj["distance"] = this.getDistance(event);

        if(window.sessionStorage){
          var sessionObject = getCtSessionObject();
          sessionObject["source"] = cTapSearchObj["search type"];
          setCtSessionObject(sessionObject);  
        }
        
        //Trigger a local search
        CT.utils.helperFunctions.tpTrack({"tp":"clevertap", "category":"local search", "values":cTapSearchObj});
        if(CT && CT.utils && CT.utils.cookies && CT.utils.cookies.create){
          CT.utils.cookies.create("lastEventType", "cleartrip home local search");
        }
      }
      var url = '/local/'+city+'/localHomePage?CThome=true';
      $.ajax({
        method: 'GET',
        url: url,
        success: function(htmlRes){
        function renderMarkup(htmlRes){
        	 $("#localLongForm").html(htmlRes).show();
             $("#localLongForm").on('click', '.localStoriesItem', trackStories);
             $("#localLongForm").on('click', '.localCollectionItem', trackCollectionCards);
             $("#localLongForm").on('click', '.localEventItem', trackEvent);
             var userScrolled = false;
             var scrollEventTriggered = false;
             $(window).scroll(function() {
               userScrolled = true;
             });
             setInterval(function() {
               if (userScrolled && !scrollEventTriggered) {
                 var scrollTop = $(window).scrollTop();
                 if(scrollTop > 630){
                   scrollEventTriggered = true;
                   var usrLocation = (CT && CT.utils && CT.utils.cookies && CT.utils.cookies.read && CT.utils.cookies.read("userLocation"))? CT.utils.cookies.read("userLocation") : "NA";
                   var lastEventType = (CT && CT.utils && CT.utils.cookies && CT.utils.cookies.read && CT.utils.cookies.read("lastEventType")) ? CT.utils.cookies.read("lastEventType") : "new session";
                   var cTapObj = {
                     "event type" : "cleartrip home local viewed",
                     "last event type" : lastEventType,
                     "city" : city,
                     "user location" : usrLocation,
                     "platform" : window.isMobileUA ? "mweb" : "desktop",
                     "carousel editorial": "no",
                     "carousel first editorial": "no",
                     "product editorial":$('#localLongForm').find('.localCollectionItem').length ? "yes" : "no",
                     "activity rows": "no",
                     "event carousel":  $('#localLongForm').find('.localEventItem') ? "yes" : "no",
                     "wishlists": "no",
                     "recently viewed":  "no",
                     "explore grid":  "no",
                     "hero content":   "no",
                     "special promotion" : "no",
                     "upcoming booking": "no",
                     "story web view" :  $('#localLongForm').find('.localStoriesItem') ? "yes" : "no",
                     "deal card" : "no",
                     "deal card image" : "no",
                   };
                   CT.utils.helperFunctions.tpTrack(
                     {"tp":"clevertap", "category":"cleartrip home local viewed", "values":cTapObj});
                   if(CT && CT.utils && CT.utils.cookies && CT.utils.cookies.create && false){
                     CT.utils.cookies.create("lastEventType", "cleartrip home local viewed");
                   }
                 };
                 userScrolled = false;
               }
             }, 50);
        }	
        
        
        if(window.resultsCSSAssetsLoaded == true){
        	renderMarkup(htmlRes)
        }else{
        	CT.subscribe('results_css_assets_loaded', function(){
        		renderMarkup(htmlRes)	
    		});
        }
        
        
        }
      })

    },
    fetchProductsForLocationv2: function(cityName , callback) {
        /*
         * BR-418
         *  Call the paidAffiliateTracker with urlParams Hash
         */
      //  window.affiliateutmExpiryDays = '1';
        window.affiliateutmExpiryDays =   window.affiliateutmExpiryDays ? window.affiliateutmExpiryDays : '1';
        var urlHash=window.location.search ? CT.utils.helperFunctions.queryToObj(window.location.search.substr(1)) :{};
        CT.utils.helperFunctions.paidAffiliateTracker(urlHash);
        try{
          $.ajax({
            method: 'GET',
            url: '/local/api/v1/ctLocalAutoComp?city=' + cityName,
            contentType: "application/json",
            dataType: "json",
            success: function(data){
              data = _.isString(data)? JSON.parse(data) : data;
              if(data[cityName]){
            	  callback(cityName , data[cityName])
              } else {
                localsHome.showCityUnavailable();
              }
            },
            error: function(err){
              console.log(err);
              localsHome.showCityUnavailable();
            }
          });
        }catch(e){
          console.log(e);
          localsHome.showCityUnavailable();
        }
      },
    fetchProductsForLocation: function(cityName) {
      try{
        $.ajax({
          method: 'GET',
          url: '/local/api/v1/ctLocalAutoComp?city=' + cityName,
          contentType: "application/json",
          dataType: "json",
          success: function(data){
            data = _.isString(data)? JSON.parse(data) : data;
            if(data[cityName]){
              localsHome.generateProductForCity(data[cityName], cityName);
            } else {
              localsHome.showCityUnavailable();
            }
          },
          error: function(err){
            console.log(err);
            localsHome.showCityUnavailable();
          }
        });
      }catch(e){
        console.log(e);
        localsHome.showCityUnavailable();
      }
    },    
    generateProductForCity: function(cityProducts, cityName) {
        cityName = cityName.toLowerCase();
        var products = _getProductHash(cityName);
        var enabledProducts = [];

        _.each(products, function(productData, productName) {
          if (cityProducts[productName]) {
            enabledProducts.push(productData);
          }
        });

        var localProductsHtml = CT.to_html('LocalProductsTemplate', {'enabledProducts': enabledProducts});     
        $('#localProducts').html(localProductsHtml);
    },
    fetchLocationFromLatLongv2: function (latitude, longitude, callback) {
        try{
          $.ajax({
            method: 'GET',
            url: '/local/api/v1/ctLocalAutoComp?latitude=' + latitude +'&longitude=' + longitude,
            contentType: "application/json",
            dataType: "json",
            success: function(data){
              data = _.isString(data)? JSON.parse(data) : data;
                _.each(data, function(val, key){
                  window.currentCityName = key;
                  window.currentCityCode = window.currentCityName.replace(/\s/g,"_");
                });
                if(data[window.currentCityName]){
                   if (CT && CT.utils && CT.utils.cookies){
                         CT.utils.cookies.create('localCurrentCity', window.currentCityName, 365);
                       }
                  if(callback)
                	  callback(window.currentCityName , data[window.currentCityName]);
                  
                } else {
                 // localsHome.showCityUnavailablev2();
                	window.currentCityName = window.localDefaultCity;
                	localsHome.fetchProductsForLocationv2(window.currentCityName.toLowerCase() , callback);
                }
            },
            error: function(err){
            	console.log(err);
              	window.currentCityName = window.localDefaultCity;
          		localsHome.fetchProductsForLocationv2(window.currentCityName.toLowerCase() , callback);
            }
          });
        }catch(e){
          console.log(e);
          	window.currentCityName = window.localDefaultCity;
    		localsHome.fetchProductsForLocationv2(window.currentCityName.toLowerCase() , callback);
        }
      },
    fetchLocationFromLatLong: function (latitude, longitude) {
      try{
        $.ajax({
          method: 'GET',
          url: '/local/api/v1/ctLocalAutoComp?latitude=' + latitude +'&longitude=' + longitude,
          contentType: "application/json",
          dataType: "json",
          success: function(data){
            data = _.isString(data)? JSON.parse(data) : data;
              _.each(data, function(val, key){
                window.currentCityName = key;
                window.currentCityCode = window.currentCityName.replace(/\s/g,"_");
              });
              if(data[window.currentCityName]){
                 if (CT && CT.utils && CT.utils.cookies){
                       CT.utils.cookies.create('localCurrentCity', window.currentCityName, 365);
                     }
                localsHome.generateProductForCity(data[window.currentCityName], window.currentCityName);
                //localsHome.fetchEditorialForLocation(window.currentCityName.toLowerCase());
              } else {
                localsHome.showCityUnavailable();
              }
          },
          error: function(err){
            console.log(err);
            localsHome.showCityUnavailable();
          }
        });
      }catch(e){
        console.log(e);
        localsHome.showCityUnavailable();
      }
    },
    showLoadingState: function() {
      $('#localCityAvailable').hide();
      $('#localEmptySpace').hide();
      $('#localLoadingState').show();
    },
    showUndetectedCity: function() {
      $('#localCityAvailable').hide();
      $('#localLoadingState').hide();
      var $localEmptySpace = $('#localEmptySpace');
      var $localLocation = $localEmptySpace.find('.localLocation');
      $localLocation.hide();
      var $undetectedCity = $localEmptySpace.find('#undetectedCityBlock');
      $undetectedCity.show();
      var $unavailableCity = $localEmptySpace.find('#unavailableCityBlock');
      $unavailableCity.hide();
      $localEmptySpace.show();
    },
    showCityUnavailable: function() {
      if(window.localDefaultCity.toLowerCase() == window.currentCityName.toLowerCase()){
    	  $('#localCityAvailable').hide();
          $('#localLoadingState').hide();
          var $localEmptySpace = $('#localEmptySpace');
          var $localLocation = $localEmptySpace.find('.localLocation');
          var $locationName = $localLocation.find('#locationName');
          $locationName.html(window.currentCityName);
          $localLocation.show();
          var $undetectedCity = $localEmptySpace.find('#undetectedCityBlock');
          $undetectedCity.hide();
          var $unavailableCity = $localEmptySpace.find('#unavailableCityBlock');
          $unavailableCity.show();
          $localEmptySpace.show();
      }else{
    	  localsHome.loadDefaultCity();
      }
    },
    showCityAvailable: function() {
      $('#localEmptySpace').hide();
      $('#localLoadingState').hide();
      $('#localCityAvailable').show();
    },
    loadDefaultCityv2: function(callback) {

    	
      if (window.localDefaultCity) {
        window.currentCityName = window.localDefaultCity.toLowerCase();
        window.currentCityCode = window.currentCityName.replace(/\s/g,"_");
        localsHome.fetchProductsForLocationv2(window.currentCityName,callback);
      } else {
        localsHome.showUndetectedCity();
      }
    },
    loadDefaultCity: function() {
    	//if(localsHome.geoTimer){
    		//clearInterval(localsHome.geoTimer)	
    	//}
    	
      if (window.localDefaultCity) {
        window.currentCityName = window.localDefaultCity.toLowerCase();
        window.currentCityCode = window.currentCityName.replace(/\s/g,"_");
        localsHome.fetchProductsForLocation(window.currentCityName);
        //localsHome.fetchEditorialForLocation(window.currentCityName);
      } else {
        localsHome.showUndetectedCity();
      }
    },
    setSpacePreference: function() {
        if (CT.utils.cookies.read('spacePreference') && CT.utils.cookies.read('spacePreference') == 'local') {
          localsHome.showLocalSpace();
        } else {
          localsHome.showTravelSpace();
        }
    },
    getGeoLocationv2: function (callback) {

        var locationSuccess = function(position) {

      	if (position.coords && position.coords.latitude && position.coords.longitude) {
            localsHome.fetchLocationFromLatLongv2(position.coords.latitude, position.coords.longitude , callback);
          } else {
            localsHome.loadDefaultCityv2(callback);
          }
        };
        var locationError = function() {
      	  localsHome.loadDefaultCityv2(callback);
        	
        	//locationSuccess({coords:{latitude:10.957955300000002,longitude:76.955338}})
        }
        if (navigator.geolocation){
          navigator.geolocation.getCurrentPosition(locationSuccess, locationError)
        }else{
      	  localsHome.loadDefaultCityv2(callback);
        }
        setTimeout(function(){
           if(window.currentCityName == undefined || window.currentCityName == ""){
           	  localsHome.loadDefaultCityv2(callback)
      	  }
        },3000); 
        
        
      },
    getGeoLocation: function () {
      //localsHome.geoTimer = setInterval(localsHome.loadDefaultCity, 2000);
      var locationSuccess = function(position) {
    	//clearInterval(localsHome.geoTimer)
    	if (position.coords && position.coords.latitude && position.coords.longitude) {
          localsHome.fetchLocationFromLatLong(position.coords.latitude, position.coords.longitude);
        } else {
          localsHome.loadDefaultCity();
        }
      };
      var locationError = function() {
    	//clearInterval(localsHome.geoTimer)
        localsHome.loadDefaultCity();
      }
      if (navigator.geolocation){
        navigator.geolocation.getCurrentPosition(locationSuccess, locationError)
      }else{
    	  //clearInterval(localsHome.geoTimer)
    	 localsHome.loadDefaultCity();
      }
      setTimeout(function(){
         if(window.currentCityName == undefined || window.currentCityName == ""){
         	  localsHome.loadDefaultCity()
    	  }
      },3000); 
      
      
    },
    localTrendingClick: function(e){
    	try{
			if(window.cleverTapEnabled){
				var collectionName = $(e).find("h5") ? $(e).find("h5").text() : "NA";
				var srpPos = -1;
				var wrap = $(e).closest(".localTrendingTiles").find(".col6");
				if(wrap){
					var thisLi = $(e).closest(".col6");
	      			srpPos = parseInt(wrap.index(thisLi)-1);
				}
	      		var cTapObj = {
					"event type" : "trending clicked",
					"last event type" : (CT && CT.utils && CT.utils.cookies && CT.utils.cookies.read && CT.utils.cookies.read("lastEventType")) ? CT.utils.cookies.read("lastEventType") : "new session",
					"city" : window.window.currentCityName ?  _.capitalize(window.currentCityName) : "NA",
					"user location" : (CT && CT.utils && CT.utils.cookies && CT.utils.cookies.read && CT.utils.cookies.read("userLocation")) ? _.capitalize(CT.utils.cookies.read("userLocation")) : "NA",
					"collection name" : collectionName,
					"collection type" : "NA",
					"activity name" :"NA",
					"activity location" : "NA",
					"price" : -1,
					"distance" : -1,
					"dx" : -1,
					"action" : "NA",
					"srp position" : srpPos,
					"platform" : window.isMobileUA ? "mweb" : "desktop"
				}
				CT.utils.helperFunctions.tpTrack({"tp":"clevertap", "category":"local action", "values":cTapObj});
			}
		}catch(e){}
		if(CT && CT.utils && CT.utils.cookies && CT.utils.cookies.create)CT.utils.cookies.create("lastEventType", "trending clicked");
    },
    initv2: function(config){
    	var fetchProductsCallback = function(cityName, cityHash){
    		var productHash = _getProductHash(cityName);
        window.localProductHash = cityHash;
    		var redirectProduct = "";
    		_.each(_.keys(productHash) , function(key){
  				if(cityHash[key] == true){
  					redirectProduct = key;
  					return false;
  				}
  			});
      	if(config.redirect == true){
          var urlHash = window.location.search ? CT.utils.helperFunctions.queryToObj(window.location.search.substr(1)) : {};
          if(urlHash.activity){
            if(window.sessionStorage && !window.sessionStorage.getItem("isRedirect")){
              window.sessionStorage.setItem("isRedirect", "true");
            }
            window.location.href = productHash[redirectProduct].url+window.location.search;
          }else{
            window.location.href=productHash[redirectProduct].url
          }
          
      	}else if (config.attachLink == true){
      		$("#"+config.localsLinkId).attr("href",productHash[redirectProduct].url)
      	} else if(config.showLocalCard == true){
          localsHome.getLocalHomePage(localProductHash);
        }
      };
    	if (window.currentCityName) {
        localsHome.fetchProductsForLocationv2(window.currentCityName.toLowerCase() , fetchProductsCallback);
      }else {
        window.currentCityName = '';
        if(CT.utils.cookies.read("localCurrentCity") != null){
        	window.currentCityName = CT.utils.cookies.read("localCurrentCity");
        	localsHome.fetchProductsForLocationv2(CT.utils.cookies.read("localCurrentCity").toLowerCase() , fetchProductsCallback);
            
        }else{
        	//localsHome.getGeoLocationv2(fetchProductsCallback);
        }
      }
    },
    init: function(switchCity) {    
      localsHome.showLoadingState();
      if (switchCity && window.currentCityName) {
    	localsHome.setEventsForLocalWeb();
        localsHome.fetchProductsForLocation(window.currentCityName.toLowerCase());
        //localsHome.fetchEditorialForLocation(window.currentCityName.toLowerCase());
      } else {
        window.currentCityName = '';
        localsHome.setEventsForLocalWeb();
        if(CT.utils.cookies.read("localCurrentCity") != null){
        	window.currentCityName = CT.utils.cookies.read("localCurrentCity");
        	localsHome.fetchProductsForLocation(CT.utils.cookies.read("localCurrentCity").toLowerCase());
          //localsHome.fetchEditorialForLocation(CT.utils.cookies.read("localCurrentCity").toLowerCase());
        }else{
        	localsHome.getGeoLocation();
        }
        if(CT && CT.utils && CT.utils.helperFunctions && CT.utils.helperFunctions.tpTrack){CT.utils.helperFunctions.tpTrack({"tp":"clevertap"});}
        try{
	        if(window.cleverTapEnabled){
				if(CT && CT.utils && CT.utils.cookies && CT.utils.cookies.read && !CT.utils.cookies.read("userLocation")){
					CT.utils.helperFunctions.setUserLocationCookie();
				}
			}
		}catch(e){}
	}
      
      // var cityName = 'Bangalore';
      // if (typeof cityName === 'undefined' || cityName === null || !cityName){
      //   localsHome.showUndetectedCity();
      // } else {
      //   window.currentCityName = window.currentCityName || cityName;
      //   window.currentCityCode = window.currentCityName.replace(/\s/g,"_");
      //   localsHome.showLoadingState();
      //   localsHome.fetchEditorialForLocation(window.currentCityName.toLowerCase());
      //   localsHome.fetchProductsForLocation(window.currentCityName.toLowerCase());
      // }
    }
  }
})();
